import fallbackImg from '../../assets/user.png'; // Import the fallback image
import { formatDistanceToNow } from 'date-fns';

// Function to format Firestore timestamp to "time ago" format
export const formatDate = (timestamp) => {
  const date = timestamp.toDate(); // Convert Firestore Timestamp to JavaScript Date object
  return formatDistanceToNow(date, { addSuffix: true }); // Format date to "time ago" format
};


export const userColumns = [
  { 
    field: "id",
    headerName: "ID",
    width: 200 
  },
  {
    field: "user",
    headerName: "Image",
    width: 30,
    renderCell: (params) => {
      const imgSrc = params.row.userImage || fallbackImg; // Use fallback image if img is null
      return (
        <div className="cellWithImg">
          <img
            className="cellImg"
            src={imgSrc}
            alt="avatar"
            onError={(e) => e.target.src = fallbackImg} // Fallback on error
          />
          {params.row.username}
        </div>
      );
    },
  },
  {
    field: "description",
    headerName: "Note",
    width: 200,
  },
  {
    field: "email",
    headerName: "Email",
    width: 200,
  },

  {
    field: "phone",
    headerName: "Phone",
    width: 200,
  },
  {
    field: "amount",
    headerName: "Amount",
    width: 120,
    renderCell: (params) => {
      return `₹${params.row.amount}`;
    },
  },
  
  {
    field: "timestamp",
    headerName: "Timestamp",
    width: 200,
    valueGetter: (params) => formatDate(params.value), // Use valueGetter to format createdAt field
  },
  {
    field: "status",
    headerName: "Status",
    width: 120,
    renderCell: (params) => {
      return (
        <div className={`cellWithStatus ${params.row.status}`}>
          {params.row.status}
        </div>
      );
    },
  },
];
